import React from 'react';

const NoContent = (props: any) => {
    return (
        <div 
            className="w-100 mt-1 border border-primary-100 bg-primary-50 rounded-lg p-2 text-primary-600 text-center"
        >
            <span>Não foram encontrados resultados</span>
        </div>
    )
}

export default NoContent;
